import HeaderDrawer from "./HeaderDrawer";
import HeaderLogin from "./HeaderLogin";
import { NavigationHeaderContext } from "./NavigationHeaderContext";
import { MenuOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import cx from 'classnames';
import React, { forwardRef, useCallback, useContext } from 'react';
var MobileHeader = /*#__PURE__*/forwardRef(function (props, ref) {
  var NavigationHeaderContextProps = useContext(NavigationHeaderContext);
  var mobileNavItem = NavigationHeaderContextProps.mobileNavItem,
    activeMenuTitle = NavigationHeaderContextProps.activeMenuTitle,
    navItem = NavigationHeaderContextProps.navItem;
  var pathname = window.location.pathname;
  var href = window.location.href;
  var calcIsActive = useCallback(function (item) {
    if (item.isActive) {
      return true;
    }
    var judgeType = item.type || 'href';
    var judgeUrl = judgeType === 'pathname' ? pathname : href;
    if (item.isExact) {
      return judgeUrl === item.href;
    } else {
      return judgeUrl.indexOf(item.href) > -1;
    }
  }, [pathname]);
  var renderMenu = function renderMenu() {
    var renderMenuBySource = function renderMenuBySource(source) {
      return source.map(function (item, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: cx('dr-nav-drawer-item', calcIsActive(item) && 'dr-nav-drawer-item-active'),
          key: index,
          onClick: function onClick() {
            if (item.onClick) {
              item.onClick(item);
            } else {
              window.open(item.href);
            }
          }
        }, item.label);
      });
    };
    if (Array.isArray(mobileNavItem)) {
      return renderMenuBySource(mobileNavItem);
    }
    if (Array.isArray(navItem)) {
      return renderMenuBySource(navItem);
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "dr-nav"
  }, /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement(HeaderDrawer, {
    ref: ref,
    button: /*#__PURE__*/React.createElement(MenuOutlined, {
      rev: undefined
    })
  }, renderMenu()), /*#__PURE__*/React.createElement("div", {
    className: "dr-nav-title"
  }, activeMenuTitle)), /*#__PURE__*/React.createElement(Space, {
    size: 24
  }, /*#__PURE__*/React.createElement(HeaderLogin, null)));
});
export default MobileHeader;